import { Dispatch, SetStateAction } from "react";
import SidebarExplorerItem from "./SidebarExplorerItem";

interface FileExplorerSidebarProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function FileExplorerSidebar({
  open,
  setOpen,
}: FileExplorerSidebarProps) {
  // TODO: Get Infinite Folders Scroll.

  if (!open) {
    return (
      <div
        className="tw:bg-superlight tw:h-fit tw:z-10 tw:px-2 tw:py-1 btn-oauth cursor-pointer tw:rounded-lg"
        onClick={() => setOpen(true)}
      >
        <i className="mdi mdi-chevron-right tw:text-dark tw:text-2xl" />
      </div>
    );
  }

  return (
    <>
      <div className="tw:bg-superlight tw:z-10 tw:w-full tw:md:w-72 tw:rounded-lg">
        <div className="tw:flex tw:justify-end">
          <i
            className="mdi mdi-chevron-left tw:cursor-pointer tw:text-2xl tw:pt-1 tw:pr-2"
            onClick={() => setOpen(false)}
          />
        </div>
        <div
          className={`tw:overflow-y-auto tw:overflow-x-hidden tw:px-2 tw:py-4 tw:m-2 tw:bg-white tw:rounded tw:max-h-100`}
        >
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={true}
            onOpen={() => {}}
            icon="mdi-folder-table"
          />
          {/* <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          />
          <SidebarExplorerItem
            name="All Files"
            id={""}
            isSelected={false}
            onOpen={() => {}}
            icon="mdi-folder-outline"
          /> */}
        </div>
      </div>
    </>
  );
}
